import React from 'react';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Menu as MenuIcon, Search as SearchIcon } from '@mui/icons-material';

import CartIconButton from '../Cart/CartIconButton';
import Logo from './Logo';

interface MobileTopBarProps {
  isSticky: boolean;
  onOpenMenu: () => void;
  onSearch: () => void;
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({
  isSticky,
  onOpenMenu,
  onSearch,
}) => {
  const theme = useTheme();
  const textColor =
    theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.text.primary;

  return (
    <AppBar
      position="sticky"
      elevation={0}
      data-testid="mobile-top-bar"
      sx={{
        top: 0,
        px: '10px',
        pt: 'max(8px, env(safe-area-inset-top))',
        pb: '8px',
        height: 'calc(70px + env(safe-area-inset-top))',
        color: textColor,
        backgroundColor: 'transparent',
        boxShadow: 'none',
        zIndex: theme.zIndex.appBar,
      }}
    >
      {' '}
      <Toolbar
        disableGutters
        sx={{
          position: 'relative',
          minHeight: '54px !important',
          height: 54,
          px: 0.75,
          borderRadius: '27px',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.22)}`,
          backgroundColor: alpha(theme.palette.background.paper, 0.84),
          backdropFilter: 'blur(14px)',
          boxShadow: isSticky
            ? '0 10px 28px rgba(15, 23, 42, 0.18)'
            : '0 5px 18px rgba(15, 23, 42, 0.1)',
          transition: 'box-shadow 200ms ease, background-color 200ms ease',
          overflow: 'hidden',
        }}
      >
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={onOpenMenu}
          sx={{ width: 40, height: 40, flexShrink: 0 }}
        >
          <MenuIcon />
        </IconButton>

        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 'calc(100% - 190px)',
            display: 'grid',
            placeItems: 'center',
            zIndex: 1,
          }}
        >
          <Logo isSticky={isSticky} textColor={textColor} mobile />
        </Box>
        <Box
          sx={{
            ml: 'auto',
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            zIndex: 2,
          }}
        >
          <IconButton
            color="inherit"
            aria-label="search"
            onClick={onSearch}
            sx={{ width: 40, height: 40 }}
          >
            <SearchIcon />
          </IconButton>
          <Box
            sx={{
              display: 'grid',
              placeItems: 'center',
              width: 40,
              height: 40,
              '& .MuiIconButton-root': { width: 40, height: 40 },
            }}
          >
            <CartIconButton color="inherit" />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MobileTopBar;
